import React from "react";

import { FooterActions } from "../../styled";
import NumbersActions from "../NumbersActions";

const AllocatedNumbersAccountContainer = ({
    TableSection,
    tableSectionProps,
    actions,
    selected,
    hasSelected,
    footerActionsDisabled,
    footerActionsLoading,
    disabledActions,
    ModalsHost,
    modalHostProps,
}) => {
    return (
        <>
            <TableSection {...tableSectionProps} />

            <FooterActions>
                <NumbersActions
                    selected={selected}
                    actions={actions}
                    disabled={!hasSelected || footerActionsDisabled}
                    loading={footerActionsLoading}
                    disabledItemValues={disabledActions}
                />
            </FooterActions>

            <ModalsHost {...modalHostProps} />
        </>
    );
};

export default AllocatedNumbersAccountContainer;
